import React from "react";
import Icon from "@ant-design/icons";

const EyeSvg = ({ width = "1rem", height = "1rem", fill = "none" }) => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width={width}
			height={height}
			viewBox={`0 0 ${width} ${height}`}
			fill={fill}
		>
			<path
				d="M1.1865 7.18807C1.1462 7.06716 1.14617 6.93626 1.18639 6.81533C1.99627 4.38067 4.29289 2.625 6.99957 2.625C9.70499 2.625 12.0007 4.37904 12.8116 6.81193C12.8519 6.93284 12.852 7.06374 12.8117 7.18467C12.0018 9.61933 9.70523 11.375 6.99855 11.375C4.29313 11.375 1.99739 9.62096 1.1865 7.18807Z"
				stroke="white"
				// stroke-width="1.00357"
				// stroke-linecap="round"
				// stroke-linejoin="round"
				strokeWidth="1.00357"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M8.7491 7C8.7491 7.9665 7.9656 8.75 6.9991 8.75C6.0326 8.75 5.2491 7.9665 5.2491 7C5.2491 6.0335 6.0326 5.25 6.9991 5.25C7.9656 5.25 8.7491 6.0335 8.7491 7Z"
				stroke="white"
				strokeWidth="1.00357"
				strokeLinecap="round"
				strokeLinejoin="round"
				// stroke-width="1.00357"
				// stroke-linecap="round"
				// stroke-linejoin="round"
			/>
		</svg>
	);
};
const EyeIcon = (props) => <Icon component={() => <EyeSvg {...props} />} />;

export default EyeIcon;
